import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './usuarioForm';
import FormatUtils from '../common/formatUtils/FormatUtils';

import { setModoTela, initForm, salvarJogador, excluirJogador as excluir, getListaJogador, setPermissao } from './usuarioActions';

class Usuario extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
        this.props.getListaJogador();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'lista' ? this.lista() : null}
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvarJogador} jogador />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
                </Content>
            </div>
        )
    }

	lista() {

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({  acesso_administrador: true, acesso_jogador: false, termo_uso: true });
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th colspan={1}>Nome</Th>
								<Th colspan={1}>E-mail</Th>
								<Th colspan={1}>CPF</Th>
								<Th colspan={1}>Telefone</Th>
								<Th colspan={1}></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.filter(item => item.acesso_jogador).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.nome}</Td>
									<Td>{item.email}</Td>
									<Td>{FormatUtils.formatarCPF(item.cpf)}</Td>
									<Td>{FormatUtils.formatarTelefone(item.telefone)}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													senha: null
												});
												this.props.initForm({
													...item,
													senha: null
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioLogado: state.auth.usuarioLogado,
	modoTela: state.usuario.modoTela,
	lista: state.usuario.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvarJogador, excluir, getListaJogador, setPermissao }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Usuario);
